import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CreatePassword from "../../../Register/Local/CreatePasswordForm";
import VerifyCode from '../../../Code/VerifyCode';

class DealerView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
    };
  }

  render() {
    return (
      <Container className="justify-content-center">
        <Col>
          <div role="main">
            <Row className="justify-content-center">
              <Col>
                <Row className="justify-content-center">
                  {this.props.showForm === "VERIFY" &&
                    <VerifyCode
                      style={this.props.style}
                      finishAuth={false}
                      payload={this.props.payload}
                      showForm={this.props.showForm}
                      signInType={this.props.signInType}
                      savePayload={this.props.savePayload}
                      saveCode={this.props.saveCode}
                      displayForm={this.props.displayForm}
                    />
                  }
                  {this.props.showForm === "PASSWORD" &&
                    <CreatePassword
                      style={this.props.style}
                      signInType={this.props.signInType}
                      payload={this.props.payload}
                      code={this.props.code}
                      displayForm={this.props.displayForm}
                      prevStep="DEALER"
                    />
                  }
                </Row>
              </Col>
            </Row>
          </div>
        </Col>
      </Container>
    );
  }
}

export default DealerView;